"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformCampaigns = exports.isEloquaCampaign = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var isEloquaCampaign = function isEloquaCampaign(campaign) {
  if (campaign.team && campaign.owner && campaign.defaultProduct) {
    return true;
  }

  return false;
};

exports.isEloquaCampaign = isEloquaCampaign;

var transformCampaigns = function transformCampaigns(campaigns, teams, users, products) {
  return campaigns.reduce(function (acc, campaign) {
    var team = teams.find(function (_ref) {
      var id = _ref.id;
      return id === campaign.teamId;
    });
    var owner = users.find(function (_ref2) {
      var id = _ref2.id;
      return id === campaign.ownerId;
    });
    var defaultProduct = products.find(function (_ref3) {
      var id = _ref3.id;
      return id === campaign.defaultGiftProductId;
    });
    var fullConfiguredCampaign = {
      id: campaign.id,
      name: campaign.name,
      team: team,
      owner: owner,
      defaultProduct: defaultProduct,
      expirationDate: campaign.expirationDate
    };

    if (isEloquaCampaign(fullConfiguredCampaign)) {
      return [].concat((0, _toConsumableArray2["default"])(acc), [fullConfiguredCampaign]);
    }

    return acc;
  }, []);
};

exports.transformCampaigns = transformCampaigns;